import { auth, doc, collection, db, onSnapshot } from '../../js/firebase.js'
import { useEffect, useState } from 'react'
import axios from 'axios' ;
import { RingLoader } from "react-spinners";
import { FaShare } from 'react-icons/fa';
import  ProfileNav  from '../profiles/ProfileNav.jsx';
import  Products  from '../products/store.jsx';
import { query, where, limit, getDocs } from 'firebase/firestore'
import { alert_error, alert_success } from '../../AppContext.js'

import { Link, NavLink, Outlet, useLocation, useNavigate , useParams  } from 'react-router-dom'

import Description from './Description.jsx' ;
import Profilebanner from './Profilebanner';
function Sellerprofiles() {
    const [user, setUser] = useState(null)
    const [shop, setshop] = useState(null)
    const [iduser, setiduser] = useState(null);
    const [username, setusername] = useState(useParams().slug_2)
    function laythongtin() {
        const apidata = {
            username: username ,
            chedo: 'laythongtin',
            dulieu: 'shop',
        }
        const headers = {
            'Content-Type': 'application/json',
        }
        axios
            .post('https://hust.media/api/account.php', apidata, headers)
            .then((response) => {
                setshop(response.data) ;
                setiduser(response.data.iduser);
                console.log(response.data.iduser) ;
            })
            .catch((error) => {
                alert_error(error)
            })
    }

    const getUserByUsername = async () => {
        console.log(username)
        const userRef = query(collection(db, 'users'), where('username', '==', username), limit(1))
        const unsubscribe = onSnapshot(userRef, (querySnapshot) => {
            if (!querySnapshot.empty) {
                const docSnapshot = querySnapshot.docs[0]
                setUser(docSnapshot.data())
                console.log(querySnapshot.docs[0].data())
            } else {
                alert_error('Ko tìm thấy thông tin shop vui lòng liên hệ admin')
                console.log('No such document!')
            }
        })
    }
    useEffect(() => {
        getUserByUsername()
    }, [username])
    useEffect(() => {
        laythongtin()
    }, [])
    return (
        <>
            {user &&  username ? (
                <div className='py-8 px-2'>
                    <Profilebanner username={username}  />
                    <div className='border-b border-gray-200 text-center font-medium text-gray-500 bg-slate-100 mt-2 py-3 px-2 rounded-sm'>
                    <ProfileNav username={username}  />

                    </div>
                    { iduser &&
                    window.location.pathname.startsWith("/shop/profile/products") ? (     
                        <Products  iduser={iduser}  /> )
                    :  (      <Outlet context={[user]} /> ) }

                </div>
            ) : (
                <div className="flex justify-center items-center h-screen">
                <RingLoader size={80} color="#0000ff" />  </div>
            )}
        </>
    )
}
export default Sellerprofiles
